import React from 'react';
import {
    useHistory,
    useParams,
} from 'react-router-dom';

import { useTopic } from 'bdvp-common/src/hooks/store';
import { useDefaultTopic } from 'bdvp-common/src/hooks/config';
import { MEDIA_CONFIG_CONTEXT } from 'bdvp-common/src/utils/constants';

import Component from '../components/LandingPage';

const LandingPage = () => {

    const history = useHistory();
    let { topicId } = useParams();
    const defaultTopic = useDefaultTopic();

    if (!topicId) {

        topicId = defaultTopic;

    }

    const {
        loading,
        loadingMore,
        data,
        error,
        fetchMoreData,
    } = useTopic(topicId, { ssr: true });

    return (
        <Component
            topicId={topicId}
            data={data}
            loading={loading}
            loadingMore={loadingMore}
            error={error}
            fetchMoreData={fetchMoreData}
            history={history}
        />
    );

};

export default LandingPage;
